<template>
<div class="col-12 col-lg-6 c">
    <div class="card card-body">
        <strong style="padding-bottom: 10px"><i class="fa fa-check-square"></i> إختر الأجهزة</strong>
        <div class="form-check" v-for="device in devices" :key="device._id">
          <label class="form-check-label">
            <input type="checkbox" class="form-check-input" v-model="selected_devices" :value="device.serial_number">
            <h5>
                {{ device.title }}
            </h5>
          </label>
        </div>
    </div>
    <div class="carsd card-body" style="padding: 0px" v-if="selected_devices.length">
        <div class="col-12 text-center g">
            <button class="btn btn-danger" @click="done()">
                <i class="fa fa-check"></i>
                إضافة مسؤول في الجهاز الآن
            </button>
        </div>
    </div>
</div>
</template>

<script>
import Ripple from "vue-ripple-directive";
import { VBModal, BModal, BFormInput } from "bootstrap-vue";
export default {
  components: {
    // Layouts
    BModal,BFormInput},
  directives: {
    Ripple,
    "b-modal": VBModal,
  },
    data(){
        return {
            method: "", // students or classrooms
            devices: [],
            user: JSON.parse(localStorage.getItem('user')),
            type: 'students',
            serial_number: '',
            title: "",
            selected_classrooms: [],
            current: {},
            pending: 0,
            students: [],
            classrooms: [],
            objloading: {},
            teachers: [],
            selected_students: [],
            selected_devices: [],
            from: new Date().toISOString().split("T")[0],
            to: new Date().toISOString().split("T")[0],
            interval: null,
            logs: []
        }
    },
    created(){
        if(!checkPer("devices")){
            this.$router.push('/NotPermitted')
            return false;
        }
        this.getDevices();
        var g = this;
        $.post(api + '/user/students/list', {
            jwt: this.user.jwt,
            q: "",
            page: 1,
            perpage: 9999
        }).then(function(r){
            g.loading = false
            if(r.status != 100){
                alert(r.response)
            }else{
                g.students = r.response;
                g.students.forEach(function(a){
                    if(!g.classrooms.includes(a.classname + ',' + a.classroom)){
                        g.classrooms.push(a.classname + ',' + a.classroom)
                    }
                })
            }
        }).fail(function(){
            g.loading = false;
        })
    },
    beforeDestroy(){
        if(this.interval){
            clearInterval(this.interval)
        }
    },
    methods: {
        timeexnow(device){
            var date = new Date().toISOString().split("T")[0];
            if(new Date() >= new Date(date + ' ' + device?.ex_from)){
                if(new Date() <= new Date(date + ' ' + device?.ex_to)){
                    return true;
                }
            }
            return false;
        },
        getDevices(){
            var g = this;
            $.post(api + '/user/devices/all', {
                jwt: this.user.jwt
            }).then(function(r){
                g.loading = false
                if(r.status != 100){
                    alert(r.response)
                }else{
                    g.devices = r.response.map(function(a){
                        return a;
                    })
                }
            }).fail(function(){
            })
        },
        done(){
            var g = this;
            $.post(api + '/user/devices/add-admin', {
                jwt: this.user.jwt,
                devices: JSON.stringify(g.selected_devices)
            }).then(function(r){
                g.loading = false
                if(r.status != 100){
                    alert(r.response, 200)
                }else{
                    alert(r.response, 100)
                }
            }).fail(function(){
            })
        },
    }
}
</script>

<style>

</style>